module.exports = __webpack_public_path__ + "img/build-engine.5fe4e0e4.png";